// import { useEffect } from "react";
// import { IClient } from "../../@types/system";
import * as Input from "../../components/Form/Input";
import { Button } from "../../components/Button";
import { Eye } from "lucide-react";
import { useLoading } from "../../store/useLoading";
import { useStore } from "../../store";
import { toast } from "react-toastify";
import api from "../../service/api";
import { useEffect, useState } from "react";
import { Loading } from "../../components/Loading";
import { EmptyList } from "../../components/EmptyList";
import { IDriver } from "../../@types/system";

export function ListDrivers() {
  const loading = useLoading((store) => store.isLoading);
  const setLoading = useLoading((store) => store.setLoading);
  const drivers = useStore((store) => store.drivers);
  const setDrivers = useStore((store) => store.setDrivers);

  const [showDriver, setShowDriver] = useState(false);
  const [driver, setDriver] = useState({} as IDriver);

  async function getData() {
    setLoading(true);
    try {
      const res = await api.get(`/motoristas`);
      setDrivers(res.data.data);
    } catch (error) {
      toast.error("Erro ao tentar carregar os dados, recarregue a página", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  function handleShowAction(driver: IDriver) {
    setShowDriver(true);
    setDriver(driver);
  }
  function handleCancel() {
    setShowDriver(false);
  }

  return (
    <>
      {loading && <Loading />}
      {!loading && drivers.length === 0 && <EmptyList />}
      {!loading && !showDriver && drivers.length > 0 && (
        <ul
          role="list"
          className="divide-y divide-gray-100  dark:divide-zinc-800"
        >
          {drivers.map((driver) => (
            <li key={driver.cod} className="flex flex-col gap-3 py-5 sm:flex-row sm:justify-between sm:gap-x-6">
              <div className="flex min-w-0 gap-x-4">
                {/* <img className="h-12 w-12 flex-none rounded-full bg-gray-50" src={person.imageUrl} alt="" /> */}
                <div className="min-w-0 flex-auto">
                  <p className="text-sm font-semibold leading-6 text-gray-900  dark:text-white">
                    {driver.nome}
                  </p>
                  <p className="mt-1 truncate text-xs leading-5 text-gray-500 dark:text-zinc-400">
                    {driver.telefone}
                  </p>
                </div>
              </div>
              <div className="shrink-0 sm:flex sm:items-center gap-x-1">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => handleShowAction(driver)}
                >
                  <Eye className="h-4 w-4 text-zinc-400" strokeWidth={3} />
                </Button>
              </div>
            </li>
          ))}
        </ul>
      )}
      {showDriver && (
        <>
          <form
            id="clients"
            className="mt-6 flex w-full flex-col gap-5 divide-y divide-zinc-200 dark:divide-zinc-800"
          >
            {/* <div className="flex items-center justify-end gap-2 pt-5">
              <Button type="button" variant="outline" onClick={handleCancel}>
                Voltar
              </Button>
            </div> */}
            <div className="grid gap-3 pt-5 lg:grid-cols-form">
              <label
                htmlFor="name"
                className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
              >
                Nome
              </label>
              <div className="flex gap-3">
                <Input.Root className={showDriver ? "bg-zinc-100" : ""}>
                  <Input.Control
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Nome"
                    value={`${driver.nome}`}
                    disabled={showDriver}
                  />
                </Input.Root>
              </div>
            </div>
            <div className="grid gap-3 pt-5 lg:grid-cols-form">
              <label
                htmlFor="telefone"
                className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
              >
                Telefone
              </label>
              <div className="flex gap-3">
                <Input.Root className={showDriver ? "bg-zinc-100" : ""}>
                  <Input.Control
                    id="telefone"
                    type="text"
                    name="telefone"
                    placeholder="Telefone"
                    value={`${driver.telefone}`}
                    disabled={showDriver}
                  />
                </Input.Root>
              </div>
            </div>

            <div className="grid gap-3 pt-5 lg:grid-cols-form">
              <label
                htmlFor="turno"
                className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
              >
                Turno
              </label>
              <div className="flex gap-3">
                <Input.Root className={showDriver ? "bg-zinc-100" : ""}>
                  <Input.Control
                    id="turno"
                    type="text"
                    name="turno"
                    placeholder="Turno"
                    value={`${driver.is_active}`}
                    disabled={showDriver}
                  />
                </Input.Root>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 pt-5">
              <Button type="button" variant="outline" onClick={handleCancel}>
                Voltar
              </Button>
            </div>
          </form>
        </>
      )}
    </>
  );
}
